import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkEditDivisionMutationVariables = Types.Exact<{
  divisionId: Types.Scalars['String'];
  projectNumbers: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type BulkEditDivisionMutation = { __typename?: 'MutationModel', projects?: { __typename?: 'ProjectsMutationModel', editDivision?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const BulkEditDivisionDocument = gql`
    mutation BulkEditDivision($divisionId: String!, $projectNumbers: [Int!]!) {
  projects {
    editDivision(divisionId: $divisionId, projectNumbers: $projectNumbers) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type BulkEditDivisionMutationFn = Apollo.MutationFunction<BulkEditDivisionMutation, BulkEditDivisionMutationVariables>;

/**
 * __useBulkEditDivisionMutation__
 *
 * To run a mutation, you first call `useBulkEditDivisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditDivisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditDivisionMutation, { data, loading, error }] = useBulkEditDivisionMutation({
 *   variables: {
 *      divisionId: // value for 'divisionId'
 *      projectNumbers: // value for 'projectNumbers'
 *   },
 * });
 */
export function useBulkEditDivisionMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditDivisionMutation, BulkEditDivisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditDivisionMutation, BulkEditDivisionMutationVariables>(BulkEditDivisionDocument, options);
      }
export type BulkEditDivisionMutationHookResult = ReturnType<typeof useBulkEditDivisionMutation>;
export type BulkEditDivisionMutationResult = Apollo.MutationResult<BulkEditDivisionMutation>;
export type BulkEditDivisionMutationOptions = Apollo.BaseMutationOptions<BulkEditDivisionMutation, BulkEditDivisionMutationVariables>;